import Repository from "./Repository";

const PAYMENT_RESOURCE = "/athlete-annual-report";
export default {
  getAthletePaymentStates(payload) {
    return Repository.get(`${PAYMENT_RESOURCE}/${payload}`);
  },
};
